// extracted by mini-css-extract-plugin
export default {"content":"Second_content__DpAVW","container":"Second_container__DPKi9"};